<template>
  <v-card
    :class="dialog ? '' : 'fill-height pa-2'"
    :color="dialog ? 'blue-grey-lighten-5' : undefined"
    :rounded="dialog ? 'lg' : undefined"
    :variant="dialog ? undefined : 'flat'"
  >
    <v-card-title :class="dialog ? 'bg-primary text-white' : undefined">
      Auto body repair, paint and refinish
    </v-card-title>
    <v-card-text class="text-body-1">
      <p class="mb-3">
        Our team can often expedite the repairs of small and minor damage,
        minimizing the downtime of your vehicle.
      </p>
      <p class="mb-3">
        Our certified I-CAR platinum class refinish technicians use the highest
        quality Glasurit 90-Line Paint System. Glasurit 90-Line is the standard
        coating for high-end manufacturers such as BMW, Mercedes-Benz, Ferrari
        and Rolls Royce.
      </p>

      <RepairInfoSteps />
    </v-card-text>

    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
defineProps({
  dialog: {
    type: Boolean,
    default: false
  }
})
</script>
